export const batteryWarning = (car, siteSettingsData) => {
  let batteryLevel = {
    warning: 25,
    critical: 10
  };
  return siteSettingsData?.GuardianCapable && !car.IsCharging && (car.BatteryLevel > batteryLevel.critical)  && (car.BatteryLevel <= batteryLevel.warning);
};